import { Icon } from '@chakra-ui/react';

const CustomDeveloperToolsIcon = (props) => (
  <Icon fill="none" {...props} viewBox="0 0 21 21" width="25px" height="25px">
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M8.40657 9.696L1.33657 16.766C1.15062 16.9517 1.0031 17.1723 0.902454 17.4151C0.801805 17.6579 0.75 17.9182 0.75 18.181C0.75 18.4438 0.801805 18.7041 0.902454 18.9469C1.0031 19.1897 1.15062 19.4103 1.33657 19.596C1.71163 19.9709 2.22025 20.1816 2.75057 20.1816C3.2809 20.1816 3.78952 19.9709 4.16457 19.596L11.2346 12.524M15.5496 12.889L19.4276 16.767C19.8025 17.1421 20.0131 17.6507 20.0131 18.181C20.0131 18.7113 19.8025 19.2199 19.4276 19.595C19.0525 19.9699 18.5439 20.1806 18.0136 20.1806C17.4832 20.1806 16.9746 19.9699 16.5996 19.595L10.3906 13.387M5.08957 4.993L2.96657 5.699L0.846573 2.164L2.26057 0.75L5.79657 2.871L5.08957 4.993ZM5.08957 4.993L7.91957 7.823"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      className="strokeBrandElToDark darkBgElToBrand"
      d="M8.40661 9.69582C7.56261 7.54282 7.72761 4.71782 9.46761 2.97782C11.2076 1.23782 14.4176 0.856825 16.1846 1.91782L13.1446 4.95782L12.8616 8.06882L15.9726 7.78682L19.0126 4.74582C20.0746 6.51382 19.6926 9.72382 17.9526 11.4628C16.2126 13.2028 13.3886 13.3678 11.2356 12.5238"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);

export default CustomDeveloperToolsIcon;
